module.exports = __webpack_public_path__ + "static/media/edge.67e1f902.png";